import i18n from '../../../i18n';

export const BAG_TRANSPORT = 'bag-transport';
export const BIKE_TRANSPORT = 'bike-transport';
export const PEOPLE_TRANSPORT = 'people-transport';
export const REGULAR_SHUTTLE = 'regular-shuttle';
export const ROADBOOK_MHIKES = 'roadbook-mhikes';
export const CAR_TRANSPORT = 'car-transport';
export const CAR_PARKING = 'car-parking';
export const CANCELLATION = 'cancellation';
export const CUSTOM = 'custom';

const names = {
    [BAG_TRANSPORT]: 'booking.bag_transport',
    [BIKE_TRANSPORT]: 'booking.bike_transport',
    [PEOPLE_TRANSPORT]: 'booking.people_transport',
    [REGULAR_SHUTTLE]: 'booking.regular_shuttle',
    [ROADBOOK_MHIKES]: 'booking.roadbook_hikes',
    [CAR_TRANSPORT]: 'booking.car_transport',
    [CAR_PARKING]: 'booking.car_parking',
    [CANCELLATION]: 'booking.cancellation',
    [CUSTOM]: 'booking.custom'
};

export const getServiceList = () => {
    return [
        {
            id: "1",
            type: BAG_TRANSPORT,
            title: 'booking.bag_transport',
            slug: 'bag-transport',
            icon: "bag-transport"
        },
        {
            id: "2",
            type: REGULAR_SHUTTLE,
            title: 'booking.regular_shuttle',
            slug: 'regular-shuttle',
            icon: "bus-regular"
        },
        {
            id: "3",
            type: CAR_TRANSPORT,
            title: 'booking.car_transport',
            slug: 'car-transport',
            icon: "car-transport"
        },
        {
            id: "4",
            type: PEOPLE_TRANSPORT,
            title: 'booking.people_transport',
            slug: 'people-transport',
            icon: "people-transport"
        },
        {
            id: "5",
            type: CAR_PARKING,
            title: "Stationnement de véhicule",
            slug: 'car-parking',
            icon: "car-parking"
        },
        {
            id: "6",
            type: BIKE_TRANSPORT,
            title: "Transport de vélo",
            slug: 'bike-transport',
            icon: "bike-transport"
        }
    ]
}

export const selectOptions = [
    {
        value: BAG_TRANSPORT,
        label: serviceName(BAG_TRANSPORT)
    },{
        value: BIKE_TRANSPORT,
        label: serviceName(BIKE_TRANSPORT)
    },
    {
        value: PEOPLE_TRANSPORT,
        label: serviceName(PEOPLE_TRANSPORT)
    },
    {
        value: REGULAR_SHUTTLE,
        label: serviceName(REGULAR_SHUTTLE)
    },
    {
        value: CAR_TRANSPORT,
        label: serviceName(CAR_TRANSPORT)
    },
    {
        value: CAR_PARKING,
        label: serviceName(CAR_PARKING)
    },
    {
        value: ROADBOOK_MHIKES,
        label: serviceName(ROADBOOK_MHIKES)
    },
    {
        value: CANCELLATION,
        label: serviceName(CANCELLATION)
    },
    {
        value: CUSTOM,
        label: serviceName(CUSTOM)
    }
];

export function serviceIconUrl(type, color = 'b') {
    return '/assets/img/icons/services/' + color + '-' + type + '.png';
}

export function serviceName(type) {
    return i18n.t(names[type]);
}
